import { render, staticRenderFns } from "./headersTables.vue?vue&type=template&id=4a8b63b6&"
import script from "./headersTables.vue?vue&type=script&lang=js&"
export * from "./headersTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports